import { render, staticRenderFns } from "./department_manager.vue?vue&type=template&id=46e91468&scoped=true"
import script from "./department_manager.vue?vue&type=script&lang=js"
export * from "./department_manager.vue?vue&type=script&lang=js"
import style0 from "./department_manager.vue?vue&type=style&index=0&id=46e91468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e91468",
  null
  
)

export default component.exports